// Google Analytics utility functions
import { ANALYTICS_CONFIG } from '../config/analytics';

// Check if Google Analytics is loaded and tracking is enabled
export const isGALoaded = () => {
  return typeof window !== 'undefined' && 
         typeof window.gtag === 'function' && 
         ANALYTICS_CONFIG.ENABLE_TRACKING;
};

// Track page views
export const trackPageView = (url, title) => {
  if (isGALoaded()) {
    window.gtag('config', ANALYTICS_CONFIG.GA_TRACKING_ID, {
      page_title: title,
      page_location: url,
    });
  }
};

// Track custom events
export const trackEvent = (action, category, label, value) => {
  if (isGALoaded()) {
    window.gtag('event', action, {
      event_category: category,
      event_label: label,
      value: value,
    });
  }
};

// Track search events
export const trackSearch = (searchTerm, category = 'search') => {
  if (isGALoaded()) {
    window.gtag('event', 'search', {
      search_term: searchTerm,
      event_category: category,
    });
  }
};

// Track clicks on external links
export const trackExternalLink = (url, linkText) => {
  if (isGALoaded()) {
    window.gtag('event', 'click', {
      event_category: 'external_link',
      event_label: url,
      event_action: linkText,
    });
  }
};

// Track downloads or file views
export const trackDownload = (fileName, fileType) => {
  if (isGALoaded()) {
    window.gtag('event', 'file_download', {
      event_category: 'engagement',
      event_label: fileName,
      file_extension: fileType,
    });
  }
};

// Track form submissions
export const trackFormSubmission = (formName, success = true) => {
  if (isGALoaded()) {
    window.gtag('event', success ? 'form_submit' : 'form_error', {
      event_category: 'form',
      event_label: formName,
    });
  }
};

// Track user engagement time
export const trackEngagement = (engagementTimeSeconds) => {
  if (isGALoaded()) {
    window.gtag('event', 'user_engagement', {
      engagement_time_msec: engagementTimeSeconds * 1000,
    });
  }
}; 